// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { i18n } from '../index'
import Header, { HEADER_TYPE_SUBPAGE } from '../header/Header'
import Container from '../../common/container/Container'
import Page from '../../common/page/Page'
import css from './noStationPage.css'

function NoStationPage() {
  return (
    <Page>
      <Header title={i18n.t('noStation.header')} showNav={false} showLogo={false} headerType={HEADER_TYPE_SUBPAGE} />
      <Container>
        <p className={css.text}>{i18n.t('noStation.title')}</p>
      </Container>
    </Page>
  )
}

export default NoStationPage
